// removed by extract-text-webpack-plugin
module.exports = {"Box":"_2XiFN","FlightAirlines":"_1y79U","ClassType":"_1isJ6","FlightStatus":"_1y7EY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerLeft/FlightInfoBoxInnerLeft.scss
// module id = 515
// module chunks = 0